(function () {
  function initSwiperWhenReady(root) {
    var swiperContainer = root.querySelector('.swiper-container');
    var paginationEl = root.querySelector('.swiper-pagination');

    if (!swiperContainer || !paginationEl) {
      return false;
    }

    if (swiperContainer.dataset.swiperInitialized === 'true') {
      return true;
    }

    var slides = swiperContainer.querySelectorAll('.swiper-slide');
    if (!slides.length || typeof Swiper === 'undefined') {
      return false;
    }

    var slidesMobile = parseInt(swiperContainer.dataset.slidesMobile, 10) || 2;
    var slidesTablet = parseInt(swiperContainer.dataset.slidesTablet, 10) || 3;
    var slidesDesktop = parseInt(swiperContainer.dataset.slidesDesktop, 10) || 5;

    new Swiper(swiperContainer, {
      slidesPerView: slidesMobile,
      spaceBetween: 20,
      loop: slides.length > slidesDesktop,
      pagination: {
        el: paginationEl,
        clickable: true
      },
      breakpoints: {
        1024: {
          slidesPerView: slidesDesktop,
          spaceBetween: 20
        },
        501: {
          slidesPerView: slidesTablet,
          spaceBetween: 20
        }
      }
    });

    swiperContainer.dataset.swiperInitialized = 'true';
    return true;
  }

  function initAll() {
    document.querySelectorAll('[data-swiper-product-slider]').forEach(function (root) {
      if (initSwiperWhenReady(root)) {
        return;
      }

      var observer = new MutationObserver(function () {
        if (initSwiperWhenReady(root)) {
          observer.disconnect();
        }
      });

      observer.observe(root, {
        childList: true,
        subtree: true
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
